import React from 'react';
import './Add_step_2.css';

import MasterButton from '../../../general_components/MasterButton/MasterButton.js';
import dates from '../../../../utils/dates';


class Add_step_2 extends React.Component {
    constructor(props) {
        super(props);

        this.calculateCollegeStart = this.calculateCollegeStart.bind(this);
    }

    calculateCollegeStart(){
        let yearsTillCollege = '';
        let birthdayYear = dates.getYearFromDate(this.props.birthday);
        let birthdayMonth = dates.getMonthFromDate(this.props.birthday);
        if (birthdayMonth <= 9 ) {
            yearsTillCollege = 18;
        } else {
            yearsTillCollege = 19;
        }
        let expectedCollegeYear = birthdayYear + yearsTillCollege;

        let expectedCollegeDate = '08/01/'+expectedCollegeYear;

        return expectedCollegeDate;
    }

    render () {   
        if (this.props.currentStep !== 2) {
            return null;
        };
        return (
           <div>
                <h2 className='center'>Let's set a savings goal for {this.props.account_name}:</h2>
        
                <form>
                    
                    <p className='form_label'>How much would you like to save?</p>
                    <input 
                        className='dropdown_input' 
                        list='target_saving_options' 
                        id='target_savings' 
                        onChange={this.props.handleChange}
                        onFocus={this.props.target_savings[0] === '$' ? null : this.props.handleDollarInput }
                        onBlur={this.props.handleDollarInput}
                        name='target_savings' 
                        placeholder='$83,080 (4 years of in-state college tuition)' 
                        value={this.props.target_savings}
                        
                        autoComplete='off'
                        maxLength={this.props.target_savings[0] === '$' ? 9 : 8}
                        />
                    <datalist id='target_saving_options'>
                        <option value='$50,000'>    $50,000</option>
                        <option value='$83,080'>    $83,080</option>
                        <option value='$100,000'>    $100,000</option>
                    </datalist>


                    <p className='form_label'>When will {this.props.account_name} need it by? Pick a target date</p>
                    <input 
                        className='dropdown_input' 
                        list='target_dates' 
                        name='target_date' 
                        id='target_date'
                        onChange={this.props.handleTargetDateChange}
                        value={this.props.target_date}
                        maxLength='10'
                        minLength='10'
                        placeholder={`${this.calculateCollegeStart()} (${this.props.account_name}'s expected college start)`}
                        autoComplete='off'
                        >
                    </input>

                    <datalist id='target_dates'>
                        <option value={this.calculateCollegeStart()}>       Expected college start year</option>
                        <option value={dates.next5Years()}>       In 5 years</option>
                        <option value={dates.nextYear()}>       Next year</option>
                    </datalist>

                </form>

               

           </div>
        );
    }
}

export default Add_step_2;

/*
                    <input 
                        type='text' 
                        id='target_savings' 
                        onChange={this.props.handleChange}
                        onBlur={this.props.handleDollarInput}
                        name='target_savings' 
                        placeholder='$83,080 (4 years of in-state college tuition)' 
                        value={this.props.target_savings}
                        autoFocus
                        autoComplete='off'
                        maxLength={this.props.target_savings[0] === '$' ? 9 : 8}
                        />                    

                    <input 
                        type='text' 
                        id='target_date' 
                        onChange={this.props.handleTargetDateChange}
                        value={this.props.target_date}
                        name='target_date' 
                        maxLength='10'
                        minLength='10'
                        placeholder={`${this.calculateCollegeStart()} (${this.props.account_name}'s expected college start)`}
                        autoComplete='off'
                         />
*/